@if (display) {
  <p-dialog [styleClass]="authenticationService?.user?.fontSize === 'SMALL' ? 'custom-form-small' : (authenticationService?.user?.fontSize === 'MEDIUM' ? 'custom-form-medium' : '')"
    header="{{ title }}"
    [(visible)]="display"
    showEffect="fade"
    [modal]="true"
    appendTo="body"
    >
<div [ngClass]="{'custom-form-small': authenticationService?.user?.fontSize === 'SMALL', 'custom-form-medium': authenticationService?.user?.fontSize === 'MEDIUM'}">
    <div class="container-md">
      <!-- FORM ERRORS -->
      <div #errorContainer>
        @if (errorMessages.length !== 0) {
          <div>
            @for (error of errorMessages; track error) {
              <div>
                <div class="alert alert-warning" role="alert">{{ error }}</div>
              </div>
            }
          </div>
        }
      </div>
      <!-- NAME -->
      <div class="row">
        <div class="col-12">
          <label for="vehicle-data-settings-name" class="form-label custom-label fw-bold small mb-2 me-2 mt-3" i18n>
					<strong>{{ 'tableManagement.vehicleStatus.form.name' | translate }} (*)</strong>
				</label>
          <input
              type="text"
              id="vehicle-data-settings-name"
              class="form-control custom-input"
              [(ngModel)]="entity.name"
              [disabled]="disableSave"
              />
        </div>
      </div>
      <!-- COLOR -->
      <div class="row mt-3">
        <div class="col-12">
          <label for="vehicle-data-settings-name" class="form-label custom-label fw-bold small mb-2 me-2" i18n>
					<strong>{{ 'tableManagement.vehicleStatus.form.color' | translate }} (*)</strong>
				</label>
          <p-colorPicker [(ngModel)]="entity.color" [inline]="true" [disabled]="disableSave"></p-colorPicker>
        </div>
      </div>
      <!-- ACTIVE -->
      @if (!isNew) {
        <div>
          <div class="row mt-3">
            <div class="col-12">
              <label for="vehicle-data-settings-name" class="form-label custom-label fw-bold small mb-2 me-2" i18n>
						{{ 'general.enabled' | translate }}
					</label>
              <input
                  class="form-check-input d-flex justify-content-center align-items-center custom-checkbox"
                  type="checkbox"
                  [(ngModel)]="active"
                  [disabled]="true"
                  />
            </div>
          </div>
        </div>
      }
    </div>
  </div>
<ng-template pTemplate="footer">
      <div class="d-flex justify-content-center bd-highlight">
        <div class="p-2 bd-highlight">
          @if (!isNew) {
            <div>
              <button class="btn custom-button" (click)="saveChanges()" i18n [disabled]="disableSave">
						{{ disableSave ? ('general.saving' | translate) : ('general.save' | translate) }}
					</button>
            </div>
          }
          @if (isNew) {
            <div>
              <button class="btn custom-button" (click)="saveChanges()" i18n [disabled]="disableSave">
						{{ disableSave ? ('general.saving' | translate) : ('general.create' | translate) }}
					</button>
            </div>
          }
        </div>
        <div class="p-2 bd-highlight">
          @if (!isNew) {
            <div>
              <button class="btn custom-button" (click)="onChangeStatus(!entity.disabled)" i18n [disabled]="disableSave">
						{{ 'general.changeStatus' | translate }}
					</button>
            </div>
          }
        </div>
      </div>
    </ng-template>
</p-dialog>
}
